import React, { useRef } from 'react';
import { ActivityIndicator } from './activity-indicator';
import {
  StyleProp,
  StyleSheet,
  TouchableOpacity,
  TouchableOpacityProps,
  ViewStyle,
} from 'react-native';
import { SvgProps } from 'react-native-svg';
import { ThemedSVGProps } from '@/styles';
import { useHover } from 'react-native-web-hooks';
import { useTheme } from '@/contexts/theme-context';

interface ActionButtonProps {
  Icon: React.ComponentType<SvgProps>;
  iconProps?: ThemedSVGProps;
  loading?: boolean;
  onPress?: () => void;
  style?: StyleProp<ViewStyle>;
}

export const ActionButton: React.FC<
  ActionButtonProps & TouchableOpacityProps
> = ({ Icon, iconProps, loading, onPress, style, ...rest }) => {
  const theme = useTheme();
  const touchableOpacityRef =
    useRef<React.ComponentRef<typeof TouchableOpacity>>(null);
  const isHovered = useHover(touchableOpacityRef);

  return (
    <TouchableOpacity
      disabled={loading}
      onPress={onPress}
      ref={touchableOpacityRef}
      style={[styles.base, isHovered ? styles.hover : null, style]}
      testID="delete-button"
      {...rest}
    >
      {loading ? (
        <ActivityIndicator size="small" />
      ) : (
        <Icon stroke={theme.colors.primary} {...iconProps} />
      )}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  base: {
    opacity: 0.4,
  },
  hover: {
    opacity: 1,
  },
});
